import React from 'react';
import { ButtonIcon, Icon, Tooltip } from '@saviynt/design-system';
import classnames from 'classnames';

import { useIspmContext } from '../../context/ispmContext';
import { DASHBOARD_HEADER_SAVI_ENGAGEICON } from '../../tests/testids';
import { useInvertedLocalize } from '../../utils/localization';
import { invertedMessages } from '../../utils/messages';

import './SaviMenuIconButton.css';

function SaviMenuIconButton(): JSX.Element {
  const { ispmState, updateIspmState } = useIspmContext();
  const l = useInvertedLocalize(invertedMessages);

  // Toggle the chat overlay visibility
  const toggleChatOverlayVisibility = () => {
    updateIspmState('isChatOverlayVisible', !ispmState.isChatOverlayVisible);
    updateIspmState('isSuggestionVisible', false);
  };

  return (
    <div
      className={classnames(
        'SaviMenuIconButton',
        ispmState.isChatOverlayVisible && 'SaviMenuIconButton--isActive'
      )}
      data-testid={DASHBOARD_HEADER_SAVI_ENGAGEICON}>
      <Tooltip
        text={l('Savi Companion')}
        placement='left'
        trigger={
          <ButtonIcon
            size='large'
            kind='saviGhost'
            icon={
              <Icon kind='SaviCompanion' size='medium' color='purple-700' />
            }
            onClick={toggleChatOverlayVisibility}
          />
        }
      />
    </div>
  );
}

export default SaviMenuIconButton;
